<template>
  <div class="page-thank gap-20">
    <div v-if="isSendOrderLoading" class="loading-container">
      <div class="spinner"></div>
      <h1>ההזמנה נשלחת</h1>
    </div>
    <div v-else-if="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
    <ThankYouPopUp
      v-else
      :isUserRatingHasBeenSent="isUserRatingHasBeenSent"
      :isSendRatingUserLoading="isSendRatingUserLoading"
      :isResetRatingUserForm="isResetRatingUserForm"
      :userRatingFormError="userRatingFormError"
      @rate="sendUserRating"
      :ord="newOrd"
      :value="isThankYouPopupDisplay"
    />
  </div>
</template>

<script>
import ThankYouPopUp from "../UI/PopUps/ThankYouPopUp.vue";
import RatingService from "../../services/RatingService";
export default {
  components: {
    ThankYouPopUp,
  },
  data() {
    return {
      newOrd: 0,
      isSendOrderLoading: false,
      errorMessage: "",
      isThankYouPopupDisplay: false,
      isSendRatingUserLoading: false,
      isUserRatingHasBeenSent: false,
      isResetRatingUserForm: false,
      userRatingFormError: "",
    };
  },
  async mounted() {
    await this.sendOrder();
  },
  methods: {
    async sendOrder() {
      this.errorMessage = "";
      const payLoadData = localStorage.getItem("cartPayload");
      const errMsg = "קרתה שגיאה בעת שליחת ההזמנה, יש לפנות למנהל המערכת";
      if (payLoadData) {
        try {
          const cartPayload = JSON.parse(payLoadData);
          if (!cartPayload) {
            this.errorMessage = errMsg;
            localStorage.removeItem("cartPayload");
            return;
          }
          this.isSendOrderLoading = true;
          const response = await this.$store.dispatch(
            "Orders/sendOrder",
            cartPayload
          );

          if (response?.ord) {
            this.newOrd = response.ord;
            this.isThankYouPopupDisplay = true;
            await this.$store.dispatch("Orders/clearCart");
          }
        } catch (error) {
          console.log(error);
          this.errorMessage = errMsg;
        } finally {
          this.isSendOrderLoading = false;
        }
      } else {
        this.errorMessage = errMsg;
      }
      localStorage.removeItem("cartPayload");
    },
    async sendUserRating({ rating, reason }) {
      if (rating >= 4) return;
      try {
        this.userRatingFormError = "";
        this.isSendRatingUserLoading = true;
        const response = await RatingService.sendUserRating({
          rating,
          reason,
        });
        if (response.data.success) {
          this.isUserRatingHasBeenSent = true;
        }
      } catch (error) {
        console.error("Error sending user rating:", error);
        this.userRatingFormError =
          error?.response?.data?.error ??
          "שגיאה בניסיון שליחת הדירוג, אנא נסו שנית מאוחר יותר";
      } finally {
        this.isSendRatingUserLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page-thank {
  color: rgb(0, 0, 0);
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .delivery-details {
    min-width: 330px !important;
  }
}
.confirm-btn {
  width: 100%;
}
.Succeeded-icon {
  width: 230px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  h1 {
    color: $primaryColor;
    font-size: 24px;
    font-weight: 400;
  }
}

.spinner {
  width: 80px;
  height: 80px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid $primaryColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.error-message {
  color: #dc3545;
  padding: 1rem;
  border-radius: 4px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
